// Активный кабинет определяется ДОМЕНОМ:
//   lovirds.store      -> знакомства
//   lovirds.business   -> бизнес и партнёр (одна точка входа, дальше по префиксу пути)
//   admin.lovirds.ru   -> админка
// Старые домены кабинетов редиректит nginx, но на всякий случай они есть и здесь.
// На localhost/IP доменов нет -> определяем по префиксу пути (как в деве раньше).
const HOST_CABINET = {
    'lovirds.store': 'dating',
    'lovirds.business': 'portal',
    'admin.lovirds.ru': 'admin',
    'admin.lovirds.store': 'admin',

    // старые домены кабинетов — если редирект в nginx вдруг не сработал
    'partner.lovirds.ru': 'portal',
    'business.lovirds.ru': 'portal',

    // резерв/лендинг/старая ссылка — пока знакомства
    'lovirds.ru': 'dating',
    'lovirds.com': 'dating',
    'app.lovirds.ru': 'dating',
};

export function getCabinet() {
    const host = window.location.hostname.replace(/^www\./, '');
    if (HOST_CABINET[host]) return HOST_CABINET[host];

    // Локальная разработка / прочее — по префиксу пути
    const path = window.location.pathname;
    if (path.startsWith('/admin')) return 'admin';
    if (path.startsWith('/business') || path.startsWith('/partner')) return 'portal';
    return 'dating';
}
